import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { InputProps } from '.';
import Input from './Input';

/**
 * Password Text Box Component that can be used where a password field is needed
 *
 * @class PasswordTextBox
 * @extends {(React.Component<FieldRenderProps & InputProps>)}
 */
class PasswordTextBox extends React.Component<FieldRenderProps<any, HTMLInputElement> & InputProps> {
	constructor(props) {
		super(props);
	}

	public render() {
		return <Input {...this.props} type="password" />;
	}
}

export default PasswordTextBox;
